export default __webpack_public_path__ + "static/media/pancreas2.c6c0cc49.jpg";